module.exports = __webpack_public_path__ + "static/media/favicon.a2449988.ico";